module.exports = __webpack_public_path__ + "media/images/flags/tk-a6f5dd9d0dc98d91b7db291a5f682783.svg";